import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useStoresPinsToFitInView } from '../../../Stores/stores.context'
import {
  GoogleApiWrapper,
  Map,
  Marker as M,
  InfoWindow as IWindow,
} from 'google-maps-react' // TODO: Change the library
import styled from 'styled-components'
import { ContactsPageProps } from '../../contactsPage.props'
import { useLocalLabels } from '@sentecacommerce-theme/lib'

const Marker: any = M
const InfoWindow: any = IWindow

const MapComponent = ({ google, pinIcon }: any) => {
  const [selectedPin, setSelectedPin] = useState<any>(null)
  const refMap = useRef<any>(null)
  const { centralStore, labels } = useLocalLabels<ContactsPageProps>()

  const coords = { lat: 42.66147, lng: 23.45646 }

  const pinsToFitInMap = useStoresPinsToFitInView()

  const mapStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  }

  /**
   * Center the map to the current pins
   */
  useEffect(() => {
    const bounds = new google.maps.LatLngBounds()

    bounds.extend(coords)
    if (!refMap.current) return

    const map = (refMap.current as any)?.map

    map.fitBounds(bounds)

    // set min zoom
    map.setZoom(Math.min(map.getZoom(), 14))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinsToFitInMap])

  const onMarkerClick = (store: any) => (_: any, marker: any) => {
    setSelectedPin({
      marker,
      store,
    })
  }

  const hideInfoWindow = () => {
    setSelectedPin(null)
  }

  const selectedStore = selectedPin?.store
  const selectedMarker = selectedPin?.marker

  // memo markers to prevent unnecessary markers initialization
  const markers = useMemo(() => {
    return (
      <Marker
        key={`Marker__${coords.lat}x${coords.lng}`}
        position={coords}
        icon={pinIcon}
        onClick={onMarkerClick(coords)}
      />
    )
  }, [pinIcon])

  return (
    <MapContainer>
      <Map
        google={google}
        style={mapStyles}
        containerStyle={mapStyles}
        ref={refMap}
        initialCenter={coords}
      >
        {markers}

        <InfoWindow
          marker={selectedMarker}
          onClose={hideInfoWindow}
          visible={Boolean(selectedMarker)}
        >
          {selectedStore && (
            <InfoWindowContentWrapper>
              <InfoWindowText>{centralStore.name}</InfoWindowText>

              <InfoWindowText>
                <strong>{labels.phoneInputLabel}:</strong>{' '}
                <a href={`tel:${centralStore.phoneNumber}`}>
                  {centralStore.phoneNumber}
                </a>
              </InfoWindowText>
              {centralStore.email && (
                <InfoWindowText>
                  <strong>{labels.emailInputLabel}:</strong>{' '}
                  <a href={`mailto:${centralStore.email}`}>
                    {centralStore.email}
                  </a>
                </InfoWindowText>
              )}
            </InfoWindowContentWrapper>
          )}
        </InfoWindow>
      </Map>
    </MapContainer>
  )
}

export const StoresMap = GoogleApiWrapper({
  apiKey: '',
})(MapComponent)

const InfoWindowContentWrapper = styled.div.attrs({
  className: 'p-3',
})`
  min-width: 14rem;
  min-height: 4rem;
`

const InfoWindowText = styled.p.attrs({
  className: 'pb-2',
})`
  color: ${({ theme }) => theme.palette?.greyTitle};

  & a {
    &:hover {
      text-decoration: underline;
    }
  }
`

const MapContainer = styled.div`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
    padding-bottom: 40%;
  }
  padding-bottom: 100%;
  position: relative;
`
